export default "__VITE_ASSET__CXThIUp3__"